import { render, staticRenderFns } from "./exCl.vue?vue&type=template&id=ba6ffb2c&scoped=true&"
import script from "./exCl.vue?vue&type=script&lang=js&"
export * from "./exCl.vue?vue&type=script&lang=js&"
import style0 from "./exCl.vue?vue&type=style&index=0&id=ba6ffb2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6ffb2c",
  null
  
)

export default component.exports